import { Box, LinearProgress, Typography, styled } from '@mui/material';

export const RegisterFormContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'flex-start',
  width: '100%',
  maxWidth: '500px',
  margin: '0 auto',
  padding: theme.spacing(2),
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(2, 3)
  },
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(2)
  }
}));

export const RegisterFormWizard = styled(Box)<{ fullscreen: string }>(
  ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(3),
    width: '100%',
    [theme.breakpoints.down('md')]: {
      gap: theme.spacing(2)
    },
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2),
      gap: theme.spacing(2)
    },
    '@media (max-height: 700px)': {
      gap: theme.spacing(2)
    }
  })
);

export const RegisterFormFooter = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'space-between'
}));

export const RegisterFormHeaderNav = styled(Box)<{ fullscreen: string }>(
  ({ theme, fullscreen }) => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    [theme.breakpoints.up('md')]: {
      width: fullscreen === 'true' ? '90vw' : '50vw'
    },
    [theme.breakpoints.down('md')]: {
      width: '90vw'
    }
  })
);

export const LogoContainer = styled(Box)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    marginLeft: theme.spacing(2),
    flex: 1
  }
}));

export const RegisterFormWizardHeader = styled(Box)(() => ({}));

export const RegisterFormWizardBody = styled(Box)<{ fullscreen: string }>(
  ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.up('md')]: {},
    [theme.breakpoints.down('md')]: {
      width: '100%'
    }
  })
);

export const RegisterFormWizardTitle = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(40),
  margin: theme.spacing(3, 0, 1, 0),
  fontWeight: 'bold',
  [theme.breakpoints.down('md')]: {
    fontSize: theme.typography.pxToRem(28),
    margin: theme.spacing(2, 0, 1, 0)
  }
}));

export const RegisterProgress = styled(LinearProgress)(({ theme }) => ({
  marginTop: theme.spacing(2),
  width: '100%'
}));
